import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'HT_DCPHASE',
  version: 1,
  label: 'Hilbert Dominant Cycle Phase',
  pane: 'sub',
  category: 'cycles',
  series: 'normal',
  precision: 2,
  order: 40,
  inputs: [],
  outputs: [line('phase', 'Phase', COLOR.purple)],
  talib: { functions: ['HT_DCPHASE'], expr: 'HT_DCPHASE(close)' },
  listed: true,
  tailSafe: true,
  // TA_HT_DCPHASE_Lookback: 32 for the Hilbert engine + 31 "to be compatible with Tradestation".
  lookback: () => 63,
}
export default def
